if(typeof require !== 'undefined'){
    // Node/CommonJS:
    require ('blueimp-file-upload/js/jquery.fileupload')
    require ('blueimp-file-upload/js/jquery.iframe-transport')
    var Sortable = require ('sortablejs/Sortable')

}


var baseMediaUrl = '/';


function SystemsightMediaUploader(element, options) {
    var defaults = {
        version: '1.0.0'
    }
    var that = this;
    that.element = element;

    that.$uploaderWrap = $(element);
    that.$mediaItems = that.$uploaderWrap.find('.media-items')
    that.$mediaItemsModal = that.$uploaderWrap.find('.media-items-modal')
    that.$fileInput = that.$uploaderWrap.find('.fileupload');//Failo pasirinkimo mygtukas
    that.$remainingCounter =  that.$uploaderWrap.find('.remaining-counter');
    that.$currentCounter =  that.$uploaderWrap.find('.current-counter');
    that.$limitCounter =  that.$uploaderWrap.find('.limit-counter');
    that.$form =  that.$uploaderWrap.closest('form')
    that.$uploadInputWrap =  that.$uploaderWrap.find('.upload-input-wrap')
    that.$messages = that.$uploaderWrap.find('.media_messages');
    that.$invalidTypes = that.$uploaderWrap.find('.invalid-types');
    that.$recommendationsInfo = that.$uploaderWrap.find('.media-recommendations');
    that.uploadSizeAlert = that.$fileInput.data('upload-size-alert');

    that.token = this.element.dataset.token || that.$form.find('input[name="_token"]').val();
    that.fileLimit = parseInt(that.$fileInput.data('file_limit')) || 1;
    that.id = that.$fileInput.data('id');
    that.item = that.$fileInput.data('entity');
    that.media_id = that.$fileInput.data('media_id');
    that.name =  that.$fileInput.data('name') || '';
    that.input_name =  that.$fileInput.data('input_name');
    that.fileUploadTime = new Date().getTime();

    that.totalFiles = 0;
    that.uploadedFiles = 0;
    that.uploadProgress = 0;
    that.pendingUploads = 0;

    that.template = that.$mediaItems.find('template').html();
    options = options || {};

    that.options = $.extend(true, {}, defaults, options);
    that.items = [];

    that.init();
}
SystemsightMediaUploader.prototype.initialize = function () {
    var that = this;
    $('.media-uploader').each(function (){
        if($(this).data('mediaUploaderInstance')) return;

        $(this).data('mediaUploaderInstance', new SystemsightMediaUploader(this));
    })
}
SystemsightMediaUploader.prototype.init = function () {
    var that = this;

    console.info('SystemsightMediaUploader inited (' + that.options.version + ')');
    var initialItems = that.$mediaItems.data('items');
    for (var i = 0; i < initialItems.length; i++){
        that.addItem(initialItems[i]);
    }

    if(that.fileLimit > 1){
        that.initSortable();
    }

    // ✅ NEW: atnaujinam label būseną po initial renderio
    that.toggleLabel();
    that.toggleButton();

    that.$mediaItems.on("click", ".action", function(e){
        e.stopPropagation();
        e.preventDefault();
        var $btn = $(this);
        if($btn.hasClass("disabled")) {
            return;
        }

        if($btn.data("confirm")) {
            var r = confirm($(this).data("confirm"));
            if (r !== true) {
                return;
            }
        }

        var mediaItemElement = $btn.closest('.media-item')[0];
        $btn.addClass('disabled');
        var callback = function (result){
            $btn.removeClass('disabled');
        }
        switch ($(this).data('action')){
            case 'download':
                that.downloadMediaItem(mediaItemElement, callback)
                break;
            case 'toggle':
                that.toggleMediaItem(mediaItemElement, callback)
                break;
            case 'edit':
                that.editMediaItem(mediaItemElement, callback)
                break;
            case 'delete':
                that.deleteMediaItem(mediaItemElement, callback)
                break;
            case 'crop':
                that.cropMediaItem(mediaItemElement, callback)
                break;
        }
    })


    that.$uploaderWrap.find('.fileinput-button').keyup(function(event){
        if (event.keyCode == 13) {
            that.$uploaderWrap.find('input').click();
        }
    });

    that.$fileInput.fileupload({
        dropZone : that.$uploaderWrap.find('.card-body'),
        sequentialUploads: true,
        //singleFileUploads: 1,
        //limitMultiFileUploads:1,
        url: baseMediaUrl+'media/upload_item',
        formData: function (form){
            return [
                {name: 'itemId', value: that.id},
                {name: 'entity', value: that.item},
                {name: 'entityId', value: that.$fileInput.data('entity_id') || null},
                {name: 'mediaId', value: that.media_id},
                {name: 'inputName', value: that.name},
                {name: 'input_name', value: that.input_name},
                {name: '_token', value: that.token},
            ]
        },
        dataType: 'json',
        beforeSend: function(xhr, data) {
            var currentItems = that.$mediaItems.find('> .media-item').length;
            var remaining = that.fileLimit - currentItems - that.pendingUploads;

            if(remaining <= 0) {
                return false;
            }

            that.pendingUploads++;

            data.url += '?uplodad_time=' + that.fileUploadTime;
            data.url += '&remaining=' + that.getRemainingCount();
        },
        done: that.onUploadDone.bind(that),
        progressall: function (e, data) {
            that.uploadProgress = parseInt(data.loaded / data.total * 50, 10);
            var progress = that.uploadProgress + parseInt(that.uploadedFiles / that.totalFiles * 50, 10);
            that.$uploaderWrap.find('.upload-progress .progress-bar').css('width', progress + '%');
        },
        start: function(e){
            that.$uploaderWrap.find(".media_messages").html('');
            that.$uploaderWrap.find('.upload-progress .progress-bar').css('width', 0 + '%');
            that.$uploaderWrap.find(".upload-progress").stop().fadeIn(500);
            that.uploadedFiles = 0;
            that.pendingUploads = 0;
            that.fileUploadTime = new Date().getTime();
            that.toggleUploadWrap(false)
        },
        add: function(e, data){
            that.totalFiles = data.originalFiles.length;
            if (
                data.autoUpload
                || (
                    data.autoUpload !== false
                    && $(this).fileupload('option', 'autoUpload')
                )
            ) {
                data.process().done(function () {
                    data.submit();
                });
            }
        },
        paste: function (e, data) {
            return false;
        },
        fail: function(e, data)
        {
            if(that.pendingUploads > 0) {
                that.pendingUploads--;
            }

            // Don't show error for canceled uploads
            if(data.textStatus === 'canceled') {
                return;
            }

            var $messages = that.$uploaderWrap.find(".media_messages");
            var msg = 'Error: upload failed';

            if(data.responseText) {
                msg = data.responseText;
            } else {
                if(data.textStatus) {
                    msg = 'Error ['+data.textStatus+']';
                }
                if(data.errorThrown) {
                    msg = ((data.textStatus) ? msg + ': ' : 'Error: ');
                    if(typeof data.errorThrown == 'string') {
                        msg += data.errorThrown;
                    } else if(data.errorThrown.message) {
                        msg += data.errorThrown.message;
                    }
                }
            }

            if(data.jqXHR.status === 413 && that.uploadSizeAlert){
                msg = that.uploadSizeAlert
            }

            console.error(msg);

            $messages.append('<small style="color:#e2706e">'+msg+'</small><br>');
            that.showRecommendationsInfo();

            that.$uploaderWrap.find('.upload-progress .progress-bar').css('width', 100 + '%');
            that.$uploaderWrap.find(".upload-progress").fadeOut(300);
            that.toggleUploadWrap(that.hasRemainingCount())
        }
    })


};
SystemsightMediaUploader.prototype.onUploadDone = function (e, data) {
    var that = this;

    if(that.pendingUploads > 0) {
        that.pendingUploads--;
    }

    if(data.result.status === 'ok'){
        for(var i=0; i<data.result.data.length; i++){
            var itemData = data.result.data[i]

            if(typeof itemData.error_message !== 'undefined'){

                var error = itemData.error_message;
                if(itemData.max){
                    error += ' ('+itemData.max+')'
                }
                if(itemData.filename){
                    error += ': <strong>'+itemData.filename+'</strong>'
                }
                if(itemData.current){
                    error += ' <strong>('+itemData.current+')</strong>'
                }
                that.$messages.append('<small class="text-danger">'+error+'</small><br>');
                that.showRecommendationsInfo();
            }else{
                that.addItem(itemData)
            }

        }
    }else{
        that.$messages.append('<small class="text-danger">'+data.result.errors+'</small><br>');
        that.showRecommendationsInfo();
    }

    that.uploadedFiles++;
    var progress = that.uploadProgress + parseInt(that.uploadedFiles / that.totalFiles * 50, 10);
    that.$uploaderWrap.find('.upload-progress .progress-bar').css('width', progress + '%');
    if(that.uploadedFiles == that.totalFiles){
        that.$uploaderWrap.find(".upload-progress").fadeOut(300);
        that.toggleUploadWrap(that.hasRemainingCount())
    }

}

SystemsightMediaUploader.prototype.deleteMediaItem = function (mediaElement, callback) {
    var that = this;

    $.post(baseMediaUrl + 'media/delete_item', {
        id: [$(mediaElement).data('itemData').id],
        entity: $(mediaElement).data('itemData').entity,
        _token: that.token
    }).done(function (result){
        if(result.status === 'ok' && result.deleted_count > 0){
            that.removeItem(mediaElement)
        }else{
            console.log(result);
        }
        callback(result)
    })

}
SystemsightMediaUploader.prototype.reloadMediaItem = function (mediaElement, callback) {
    var that = this;

    $.ajax(baseMediaUrl + 'media/get_item_data', {
        data: {
            id: $(mediaElement).data('itemData').id,
            entity: $(mediaElement).data('itemData').entity,
        }
    }).done(function (result){
        that.updateItemData($(mediaElement), result);
        callback(result)
    })
}
SystemsightMediaUploader.prototype.downloadMediaItem = function (mediaElement, callback) {
    var that = this;

    var url = $(mediaElement).data('itemData').url;
    var title = $(mediaElement).data('itemData').title;

    var link = document.createElement('a');
    link.href = url;
    link.download = title;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    that.reloadMediaItem(mediaElement, callback)
}
SystemsightMediaUploader.prototype.editMediaItem = function (mediaElement, callback) {
    var that = this;

    $.fancybox.open({
        afterClose: function (e) {
            that.reloadMediaItem(mediaElement, callback)
        },
        type: 'iframe',
        src: baseMediaUrl + 'media/edit_item?id=' + $(mediaElement).data('itemData').id + '&entity=' + $(mediaElement).data('itemData').entity,
        toolbar  : false,
        smallBtn : true,
        iframe : {
            preload : false
        },
        baseClass: 'fancybox-iframe-edit',
    });
}
SystemsightMediaUploader.prototype.cropMediaItem = function (mediaElement, callback) {
    var that = this;

    $.fancybox.open({
        afterClose: function (e) {
            that.reloadMediaItem(mediaElement, callback)
        },
        type: 'iframe',
        src: baseMediaUrl + 'media/crop_item?id=' + $(mediaElement).data('itemData').id + '&entity=' + $(mediaElement).data('itemData').entity,
        toolbar  : false,
        smallBtn : true,
        iframe : {
            preload : false
        },
        baseClass: 'fancybox-iframe-edit',
    });
}

SystemsightMediaUploader.prototype.toggleMediaItem = function (mediaElement, callback) {
    var that = this;
    $.get(baseMediaUrl + 'media/toggle_item', {
        id: $(mediaElement).data('itemData').id,
        entity: $(mediaElement).data('itemData').entity,
        _token: that.token,
    }).done(function (result){
        if(result.visible){
            $(mediaElement).removeClass('unpublished');
        }else{
            $(mediaElement).addClass('unpublished');
        }

        if(callback){
            callback(result)
        }
    })
}
SystemsightMediaUploader.prototype.initSortable = function () {
    var that = this;

    var sortableInstance = new Sortable(that.$mediaItems[0], {
        animation: 150,
        //filter: '.select2-search__field, .select2-search--inline',
        onEnd: function (event){
            var id = that.$uploaderWrap.find('.fileupload').data('id');
            var entity = that.$uploaderWrap.find('.fileupload').data('entity');
            var name = that.$uploaderWrap.find('.fileupload').data('name');

            var positions = {};
            that.$uploaderWrap.find('.media-item').each(function (index, el){
                positions[$(this).data('itemData').id] = index;
            })

            $.post(
                baseMediaUrl + 'media/sort_item',
                {
                    entity: entity,
                    positions: positions,
                    _token: that.token
                }
            );
        },
        onStart: function (event){

        }
    });
}

SystemsightMediaUploader.prototype.removeItem = function (mediaElement) {
    var mediaId = $(mediaElement).attr('data-media-id');

    var that = this;
    $(mediaElement).remove();
    that.$mediaItemsModal.find('[data-media-id="' + mediaId + '"]').remove();

    that.updateRemainingCounter()
    that.updateCounter();
    that.toggleUploadWrap(that.hasRemainingCount());

    that.toggleLabel();
    that.toggleButton();

    that.$uploaderWrap.trigger('change');
}
SystemsightMediaUploader.prototype.addItem = function (itemData) {
    var that = this;
    var template = that.template.replaceAll('[id]', itemData.id)
    var $item = $(template);

    that.updateItemData($item, itemData);

    $item.attr('data-media-id', itemData.id);

    that.$mediaItems.append($item)
    that.$mediaItemsModal.append($item.clone())
    that.updateRemainingCounter()
    that.updateCounter();

    that.toggleLabel();
    that.toggleButton();

    that.$uploaderWrap.trigger('change');
    return $item;
}
SystemsightMediaUploader.prototype.updateItemData = function ($item, itemData) {

    $item.data('itemData', itemData);
    $item.find('input[data-media-holder]').val(itemData.id);

    $item.find('media-preview')
        .removeAttr('data-fancybox')
        .removeAttr('data-type')
        .attr('href', '#')
        .attr('target', null);

    var $view = $item.find('a.media-view');
    var viewUrl = itemData.safe_url || itemData.url;

    if (!$view.length) {
        $view = $('<a class="media-view d-none"></a>');
        $item.append($view);
    }

    $view
        .removeAttr('data-fancybox')
        .removeAttr('data-type')
        .attr('href', viewUrl)
        .attr('target', '_blank')
        .attr('rel', 'noopener');

    // $view.attr('download', itemData.title || '');

    if (itemData.mime && itemData.mime.indexOf('image') === 0 && !itemData.safe_url) {

        $item.find('img').attr('src', itemData.thumbnail);

        $view
            .attr('data-fancybox', '')
            .attr('data-type', 'image')
            .attr('href', itemData.preview)
            .removeAttr('download');

        $item.find('.start-info').html(itemData.width + 'x' + itemData.height);
        $item.find('.card-icon-top').attr('class', 'ph ph-file ph-file-' + itemData.ext);

    } else if (
        itemData.mime &&
        (
            itemData.mime.indexOf('video') === 0 ||
            itemData.mime.indexOf('audio') === 0
        )
    ) {

        $item.find('[data-action="crop"]').remove();

        $view
            .attr('data-fancybox', '')
            .attr('data-type', 'iframe')
            .attr('href', viewUrl)
            .removeAttr('download');

        $item.find('.card-icon-top').attr('class', 'ph ph-file ph-file-' + itemData.ext);

    } else {

        $item.find('[data-action="crop"]').remove();
        $item.find('.card-icon-top').attr('class', 'ph ph-file ph-file-' + itemData.ext);
    }

    $item.find('.card-title').html(itemData.title);
    $item.find('.end-info').html(itemData.size);

    if (!itemData.visible) {
        $item.addClass('unpublished');
    }
}

// paslepiam/rodome label priklausomai nuo ar yra failų
SystemsightMediaUploader.prototype.toggleLabel = function () {
    var that = this;

    var $formGroup = that.$uploaderWrap.closest('.form-group');
    var $label = $formGroup.find('> label').first();
    var $uploadWrap = that.$uploadInputWrap;

    var current = that.$mediaItems.find('> .media-item').length;
    var limit = that.fileLimit;

    var canUploadMore = (!limit || isNaN(limit)) ? true : (current < limit);

    var hasFiles = current > 0;
    var isMediaUploaded = $formGroup.hasClass('media-uploaded') || hasFiles;

    $formGroup.toggleClass('media-uploaded', hasFiles);

    // $label.toggleClass('d-none', !canUploadMore);

    /*
    if ($label.length && isMediaUploaded && hasFiles && canUploadMore) {
        if (!$label.parent().is($uploadWrap)) {
            $label.prependTo($uploadWrap);
        }
    }
    */
};

SystemsightMediaUploader.prototype.toggleButton = function () {
    var that = this;

    var filesCount = that.$mediaItems.find('> .media-item').length;
    var hideButton = filesCount >= that.fileLimit;

    var $formGroup = that.$uploaderWrap.closest('.form-group');
    var $button = $formGroup.find('button[data-bs-toggle="modal"]');

    $button.toggleClass('d-none', hideButton);
}

SystemsightMediaUploader.prototype.toggleUploadWrap = function (show) {
    var that = this;
    if(show && that.$uploadInputWrap.hasClass('d-none')){
        that.$uploadInputWrap.removeClass('d-none')
    }else if (!show && !that.$uploadInputWrap.hasClass('d-none')){
        that.$uploadInputWrap.addClass('d-none')
    }
}
SystemsightMediaUploader.prototype.updateCounter = function () {
    var that = this;
    if(that.$currentCounter.length){
        that.$currentCounter.html(that.$mediaItems.find('> .media-item').length);
    }
}
SystemsightMediaUploader.prototype.updateRemainingCounter = function () {
    var that = this;
    if(that.$remainingCounter.length){
        that.$remainingCounter.html(that.getRemainingCount());
    }
}

SystemsightMediaUploader.prototype.hasRemainingCount = function () {
    var that = this;
    return that.getRemainingCount() > 0;
}
SystemsightMediaUploader.prototype.getRemainingCount = function () {
    var that = this;
    return that.fileLimit - that.$mediaItems.find('> .media-item').length;
}

SystemsightMediaUploader.prototype.showRecommendationsInfo = function () {
    this.$recommendationsInfo.slideDown();
}






if (typeof module === "object" && typeof module.exports === "object"){
    //node modules support
    SystemsightMediaUploader.prototype.initialize();
    module.exports = SystemsightMediaUploader
}else{
    $(function () {
        if (typeof baseHref != 'undefined') {
            baseMediaUrl  = baseHref;
        }
        SystemsightMediaUploader.prototype.initialize();
    });
}
